export default __webpack_public_path__ + "static/media/instagram.21480e89.svg";